import React from "react";

// ONE GRAMMAR for actionables, used by Today, the board's cards, the contact
// page's action bar and Follow-ups.
//
// Yellow FILL means "you, now", and nothing else in the system is allowed to use
// it: red stays warnings (stale, declining metrics), outlines stay states (stage,
// channel, source). The label always carries a VERB — "nudge due", "reply
// waiting", "update stage?" — because a chip that names a noun is a status, and
// statuses are the outlined pills. The server sends the label already written
// (src/actions/model.js ACTIONS), so all four surfaces say the same words.
//
// The chip never invents urgency it wasn't given: `overdue` actions render in the
// neutral treatment, because a 96-day-old "reply waiting" is a backlog item and
// dressing it as today's work is how a to-do list stops being believed.
export default function ActionChip({ action, count = 0, title }) {
  if (!action) return null;
  const overdue = !!action.overdue;
  return (
    <span
      className={`crm-actchip${overdue ? " crm-actchip--backlog" : ""}`}
      title={title || [action.detail, overdue ? "(past its window — see Follow-ups)" : null].filter(Boolean).join(" ")}
    >
      {/* The same bolt as the contact page's action bar, so a card on the board
          and the page it opens mark "you, now" with one sign. */}
      <span className="crm-actchip__bolt" aria-hidden="true">⚡</span>
      {action.label}
      {count > 0 && <span className="crm-actchip__more crm-num">+{count}</span>}
    </span>
  );
}
